import { apiGet } from "./http";

export interface MemberLevelChangeLogDto {
  id: string;
  oldLevel: string;
  newLevel: string;
  note: string | null;
  operator: string;
  createdAt: string;
}

export function fetchMemberLevelChangeLogs(tenantLegacyId: string, memberLegacyId: string) {
  return apiGet<MemberLevelChangeLogDto[]>(
    `/api/tenants/${tenantLegacyId}/members/${encodeURIComponent(memberLegacyId)}/level-change-logs`,
  );
}
